<template>
  <div class="ui segment">

    <form class="ui form">
      <h3 class="ui dividing header">Reģistrācija</h3>
	  
      <div class="ui negative icon message" v-if="error">
        <i class="warning circle icon"></i>
        <div class="content">
        <div class="header">
          Lūdzu aizpildi visus laukus:
        </div>
        <ul class="list">
          <li v-for="item in error">{{item[0]}}</li>
        </ul>
      </div>
      </div>
	  
      <div class="two fields">
        <div class="field">
          <label>Klienta veids</label>
			<select class="ui fluid dropdown" id="person_type" v-model="userObj.person_type">
               <option v-for="item in userType" v-bind:value="item.id" >{{item.label}}</option>
            </select>
        </div>
        <div class="field" v-if="userObj.person_type == 1">
          <label>Personas kods</label>
          <input type="text"  placeholder="Personas kods, piemēram, 111111-11111"   maxlength="12" v-model="userObj.legalid">
        </div>
        <div class="field" v-else>
          <label>Reģistrācijas nr.</label>
          <input type="text"  placeholder="Reģistrācijas nr., piemēram, 40000000000"   maxlength="11" v-model="userObj.legalid">
        </div>
      </div>
      <div class="field">
        <div class="two fields">
          <div class="field">
            <label v-if="userObj.person_type == 1">Vārds</label>
            <label v-else>Nosaukums</label>
            <input type="text"  placeholder="Vārds" v-if="userObj.person_type == 1" v-model="name_surname1">
            <input type="text"  placeholder="Nosaukums" v-else="userObj.person_type" v-model="name_surname1">
          </div>
          <div class="field" v-if="userObj.person_type == 1">
            <label>Uzvārds</label>
            <input type="text"  placeholder="Uzvārds" v-model="name_surname2">
          </div>
        </div>
      </div>
      <div class="field">
        <div class="two fields">
          <div class="field">
            <label>E-pasts</label>
            <input type="text"  placeholder="E-pasts" v-model="userObj.email">
          </div>
          <div class="field">
            <label>Tālrunis</label>
            <input type="text"  placeholder="Tālrunis" v-model="userObj.phone">
          </div>
        </div>
      </div>
      <div class="field">
        <div class="two fields">
          <div class="field">
            <label>Parole</label>
            <input type="password"  placeholder="Parole - vismaz 8 simboli" v-model="userObj.password">
          </div>
          <div class="field">
            <label>Parole atkārtoti</label>
            <input type="password"  placeholder="Parole atkārtoti" v-model="userObj.password2">
          </div>
        </div>
      </div>

      <div class="two fields">
        <div class="field">
          <label>Kur Jūs par mums uzzinājāt?</label>
          <select class="ui fluid dropdown" id="person_type" v-model="userObj.reference">
               <option value="">&nbsp;</option>
               <option v-for="item in reference" v-bind:value="item.id">{{item.label}}</option>
            </select>
        </div>
        <!--div class="field">
          <label>Vēstnieka ID</label>
          <input type="text" placeholder="Vēstnieka ID" v-model="userObj.parent_id">
        </div-->
      </div>

      <template v-for="addressItem in userObj.address">
        <div class="ui hidden divider"></div>
       <h4 class="ui dividing header" v-if="addressItem.is_legal_address">Juridiskā adrese</h4>
       <h4 class="ui dividing header" v-else>Piegādes adrese</h4>
       <div class="two fields">
         <div class="field">
           <label>Pilsēta</label>
           <select class="ui fluid dropdown" v-model="addressItem.city">
             <option value="">&nbsp;</option>
             <option v-for="item in city" v-bind:value="item.id">{{item.label}}</option>
           </select>
         </div>
         <div class="field">
           <label>Reģions</label>
           <select class="ui fluid dropdown" v-model="addressItem.region">
             <option value="">&nbsp;</option>
             <option v-if="!addressItem.is_legal_address" v-for="item in filteredRegion" v-bind:value="item.id">{{item.label}}</option>
             <option v-if="addressItem.is_legal_address" v-for="item in filteredRegionLegal" v-bind:value="item.id">{{item.label}}</option>
           </select>
         </div>
       </div>
       <div class="field">
         <div class="three fields">
           <div class="field">
             <label>Iela</label>
             <input type="text"  placeholder="Iela" v-model="addressItem.street">
           </div>
           <div class="field">
             <label>Mājas nr. / nosaukums</label>
             <input type="text"  placeholder="Mājas nr. / nosaukums" v-model="addressItem.house_no">
           </div>
           <div class="field">
             <label>Dzīvokļa nr.</label>
             <input type="text"  placeholder="Dzīvokļa nr." v-model="addressItem.flat_no">
           </div>
         </div>
       </div>
       <div class="field" v-if="!addressItem.is_legal_address">
         <div class="two fields">
           <div class="field">
             <label>Tālrunis</label>
             <input type="text" class="address-phone" placeholder="Norādiet tālruni kurjeram" v-model="addressItem.phone">
           </div>
           <div class="field">
             <label>Piezīmes</label>
             <input type="text"  placeholder="Piemēram, durvju kods" v-model="addressItem.notes">
           </div>
         </div>
       </div>
       <div class="field" v-if="userObj.person_type > 1 && !addressItem.is_legal_address">
         <div class="ui checkbox">
           <input id="newsletter" type="checkbox" v-model="hideLegalAddress" v-on:change="legalAddressToogle">
           <label for="newsletter">Piegādes adrese sakrīt ar juridisko</label>
         </div>
       </div>
     </template>

     <h4 class="ui dividing header">&nbsp;</h4>


       <div class="field">
         <div class="ui checkbox">
           <input value="1" type="checkbox" v-model="userObj.confirmed_agreement" number>
           <label>Esmu izlasījis un piekrītu <a href="https://api.memorywater.lv/files/ligums.pdf" target="_blank">līguma noteikumiem.</a></label>
         </div>
       </div>


      <div :class="{disabled: !userObj.confirmed_agreement}" class="ui custom_brown button" @click="registerUser">Izveidot profilu</div>
    </form>
</div>
</template>

<script>

export default {
  data () {
    return {
      id:0,
      hideLegalAddress: true,
      name_surname1: '',
      name_surname2:'',
      userObj:{
        person_type:1,
        register:true, //will trigger different behaviro in backend
        name_surname:'',
        legalid: '',
        password:'',
        password2:'',
        email: '',
        lyones_id: '',
        //parent_id: '',
        phone:'',
        confirmed_agreement:0,
        address:[{
            is_legal_address:0,
            city:0,
            region:0,
            street:'',
            house_no:'',
            flat_no:'',
            phone:'',
            notes:''
        }],
        cartid: '',
      }
    }
  },
  watch:{
       'name_surname1': 'setNameSurname',
       'name_surname2': 'setNameSurname',
	   'userObj.phone': 'setAddressItemPhone'
   },
  computed: {
    error() {
      return this.$store.state.userStore.status.error
    },
    user() {
      return this.$store.state.userStore.user
    },
    userType() {
      return this.$store.state.userStore.type
    },
    reference() {
      return this.$store.state.referenceStore.items
    },
    city() {
      return this.$store.state.addressStore.city
    },
    region() {
      return this.$store.state.addressStore.region
    },

    filteredRegion(){
      var self = this
      return self.$store.state.addressStore.region.filter(function(e) { return e.city_id == self.userObj.address[0].city});
    },
    filteredRegionLegal(){
      var self = this
      if(self.userObj.address[1]){
        return self.$store.state.addressStore.region.filter(function(e) { return e.city_id == self.userObj.address[1].city});
      }
     else return []
    }
  },

  activated(){
      this.$store.dispatch('loadUser').then((response) => {
        //if user is registered then redirect to home page
          if (response.data.user.role > 0) {
            this.$router.push({
                name: 'home'
            });
          }
//		  else {
//			var parentID = this.$route.params.parentid ? this.$route.params.parentid : false;
//			if (parentID) {
//				this.userObj.parent_id = parentID;
//			}
//		  }
      }).catch((error) => {
          console.error('Cart was not loaded')
      });
      this.$store.dispatch('loadPersonType');
      this.$store.dispatch('loadReferences');

      this.$store.dispatch('loadCity');
      this.$store.dispatch('loadRegion');
  },

  methods:{
    setNameSurname(){
       if(this.userObj.person_type == 1){
          this.userObj.name_surname = (this.name_surname1 != '') ? this.name_surname1 + ' '+this.name_surname2 : '';
       }
       else this.userObj.name_surname = this.name_surname1;
    },
	
    setAddressItemPhone(){
       for (var i = 0; i < this.userObj.address.length; i++) {
           this.userObj.address[i].phone = this.userObj.phone;
       }
    },
	
    phoneToogle(item,i){
      this.address.items[i].phone = (this.samePhone) ?  this.user.data.phone : '';
    },

    legalAddressToogle(){
      if(this.hideLegalAddress){
        this.userObj.address.splice(1,1); //remove last item
      }
      else{
        this.userObj.address.push({
                                       is_legal_address:1,
                                       city:0,
                                       region:0,
                                       street:'',
                                       house_no:'',
                                       flat_no:'',
                                       phone:'',
                                       notes:''

                                          });
      }
    },

    registerUser(){
        this.userObj.id = this.user.id;
        //huiohuio
        this.userObj.cartid = (this.cart && this.cart.id) ? this.cart.id : 0;
        
        this.$store.dispatch('updateUser', this.userObj).then((response) => {
          fbq('track', 'CompleteRegistration');
          this.$router.push({
              name: 'cart'
          });
          //this.$store.dispatch('loadActiveCart', this.cart.id);
        }).catch((error) => {
          //console.error('Cart was not loaded');
          window.scrollTo(0, 0);
        });
    }

  }
}
</script>


// WEBPACK FOOTER //
// RegisterUserPage.vue?6f5c2173